// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__33KTx","assignButton":"CreateEditEquipmentSchedule_assignButton__35OEm"};